import { dialogDefault, OPEN_DIALOG_SCLERAL, CLOSE_DIALOG_SCLERAL } from "../consts";

const mydialog = { ...dialogDefault }

export const openDialogScleral = id => ({ type: OPEN_DIALOG_SCLERAL, payload: { open: true, id } });
export const closeDialogScleral = () => ({ type: CLOSE_DIALOG_SCLERAL, payload: { open: false, id:0 } });

export default function scleralDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [OPEN_DIALOG_SCLERAL] : () => ({...state, ...payload }),
        [CLOSE_DIALOG_SCLERAL] : () => ({...state, ...payload }),
    }

    return actions[type]?.call() || state;
}